import type { SetupCheck } from '@pqrs/contracts';
import { Badge } from '@xiltrion/ui/badge';
import { Icono } from '@xiltrion/ui/icono';
import { Item, ItemActions, ItemContent, ItemDescription, ItemGroup, ItemMedia, ItemTitle } from '@xiltrion/ui/item';

/** Cada requisito con su estado en texto (no solo en color): listo, obligatorio o recomendado. */
export function SetupChecklist({ checks }: { checks: SetupCheck[] }) {
  return (
    <ItemGroup className="gap-2">
      {checks.map((c) => {
        const tone = c.ok ? 'text-success' : c.level === 'required' ? 'text-destructive' : 'text-warning';
        return (
          <Item key={c.code} variant="outline" size="sm">
            <ItemMedia variant="icon"><Icono nombre={c.ok ? 'mdi:check-circle' : c.level === 'required' ? 'mdi:alert-circle' : 'mdi:alert-outline'} className={tone} aria-hidden /></ItemMedia>
            <ItemContent>
              <ItemTitle>{c.title}</ItemTitle>
              <ItemDescription className="line-clamp-none">{c.detail}</ItemDescription>
            </ItemContent>
            <ItemActions>
              <Badge variant={c.ok ? 'success-light' : c.level === 'required' ? 'destructive-light' : 'warning-light'}>{c.ok ? 'Listo' : c.level === 'required' ? 'Obligatorio' : 'Recomendado'}</Badge>
            </ItemActions>
          </Item>
        );
      })}
    </ItemGroup>
  );
}
